import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '../../assets/icons/chevronLeft.js';
import ChevronRightIcon from '../../assets/icons/chevronRight.js';
import { useTranslation } from 'react-i18next';

function NavigationButtons({ 
    onPrevious, 
    onNext, 
    previousLabel, 
    nextLabel,
    previousDisabled = false,
    nextDisabled = false,
    showPrevious = true,
    showNext = true,
    previousPath,
    nextPath,
    align = 'space-between',
    nextStyleOverride
}) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const prevLabel = previousLabel || t('navPrevious');
    const nextLbl = nextLabel || t('navNext');

    const handlePrevious = () => {
        if (previousPath) {
            navigate(previousPath);
        } else if (onPrevious) {
            onPrevious();
        }
    };

    const handleNext = () => {
        if (nextPath) {
            navigate(nextPath);
        } else if (onNext) {
            onNext();
        }
    };

    const buttonStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '13px 24px',
        borderRadius: '6px',
        fontSize: '16px',
        fontWeight: '500',
        fontFamily: 'Manrope',
        cursor: 'pointer',
        transition: 'all 0.2s',
        border: 'none',
        minWidth: '120px',
        justifyContent: 'center'
    };

    const previousStyles = {
        ...buttonStyles,
        background: previousDisabled ? 'var(--disabled-color)' : '#fff',
        color: previousDisabled ? '#fff' : '#000',
        border: previousDisabled ? 'none' : '1px solid #000',
        cursor: previousDisabled ? 'not-allowed' : 'pointer'
    };

    const nextStyles = {
        ...buttonStyles,
        background: nextDisabled ? 'var(--disabled-color)' : 'var(--brand-green-dark)',
        color:'#fff',
        cursor: nextDisabled ? 'not-allowed' : 'pointer',
        ...nextStyleOverride
    };

    const containerStyles = {
        display: 'flex',
        justifyContent: align === 'center' ? 'center' : 'space-between',
        alignItems: 'center',
        width: '100%',
        maxWidth: '1000px',
        margin: '0 auto',
        padding: '20px',
        boxSizing: 'border-box',
        backgroundColor: 'var(--background-color)',
    };

    return (
        <div style={containerStyles}>
            {showPrevious ? (
                <button
                    style={previousStyles}
                    onClick={handlePrevious}
                    disabled={previousDisabled}
                    data-testid="previous-button"
                >
                    <ChevronLeftIcon />
                    {prevLabel}
                </button>
            ) : (
                <div></div>
            )}

            {showNext ? (
                <button
                    style={nextStyles}
                    onClick={handleNext}
                    disabled={nextDisabled}
                    data-testid="next-button"
                >
                    {nextLbl}
                    <ChevronRightIcon />
                </button>
            ) : (
                <div></div>
            )}
        </div>
    );
}

NavigationButtons.propTypes = {
    onPrevious: PropTypes.func,
    onNext: PropTypes.func,
    previousLabel: PropTypes.string,
    nextLabel: PropTypes.string,
    previousDisabled: PropTypes.bool,
    nextDisabled: PropTypes.bool,
    showPrevious: PropTypes.bool,
    showNext: PropTypes.bool,
    previousPath: PropTypes.string,
    nextPath: PropTypes.string,
    align: PropTypes.string,
    nextStyleOverride: PropTypes.object
};

export default NavigationButtons; 